import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';

import Grid from '@material-ui/core/Grid';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';

import ItemCalender from '../../atoms/Calendar/ItemCalender';
import { TM_TRD_GROUP_SET } from '../../../function/GroupDataModel';

import TrendGraphItemHeader from './TrendGraphItemHeader';
import TrendGraphChart, { GraphDispSetting } from './TrendGraphChart';
import TrendGraphChartSetting from './TrendGraphChartSetting';
import {
  TrendGraphPageDataType,
  TrendManagementSettingType,
  createDefaltTrendSetting,
  GetTrendSettingList,
} from './TrendGraph';
import TrendGraphPageComboBox from './TrendGraphPageComboBox';
import TrendGraphItemInfoList from './TrendGraphItemInfoList';
import TrendGraphButtonList from './TrendGraphButtonList';
import TrendGraphDaySelects from './TrendGraphDaySelects';
import { useTranslation } from 'react-i18next';
import { useModal } from '../../../function/useModal';
import TrendSettingDialog, { TrendSettingDialogResponse } from '../../molecules/Dialog/TrendSettingDialog';
import DateInput from '../../atoms/Calendar/DateInput';

const useStyles = makeStyles(
  createStyles({
    responsiveContainer: {
      minHeight: 'calc(100vh - 470px)',
      maxHeight: 'calc(100vh - 470px)',
    },
    tableCell: {
      padding: '0px',
      borderBottomWidth: '0px',
    },
  })
);

const createDefaltTrendSettingList = (count: number): TrendManagementSettingType[] => {
  var list: TrendManagementSettingType[] = [];
  for (let i = 0; i < count; i++) {
    list.push(createDefaltTrendSetting());
  }
  return list;
};

type Props = {
  location: { state: TM_TRD_GROUP_SET };
};

const TrendGraphPage: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const selectDay: string = dayjs(new Date()).subtract(1, 'year').add(1, 'day').format('YYYY-MM-DD'); //うるう年考慮

  //画面選択中のグループ番号
  const [trendGraphPageData, setTrendGraphPageData] = useState<TrendGraphPageDataType>({
    selectGroupNo: props.location.state != undefined ? props.location.state.GROUP_NO : 1,
    targetDay: dayjs(new Date()).subtract(1, 'year').add(1, 'day').format('YYYY-MM-DD'), //うるう年考慮
    dataUpDateTime: '',
  });

  //選択データの対象日時
  const [trendSettingList, setTrendSettingList] = useState<TrendManagementSettingType[]>(
    createDefaltTrendSettingList(8)
  );

  const [date1, setDate1] = useState<string>('');
  const [date2, setDate2] = useState<string>('');
  const [date3, setDate3] = useState<string>('');
  const [selectIndex, setSelectIndex] = useState<number>(1);

  //Y軸 最大/最小 入力データ
  const [graphDispSetting, SetGraphDispSetting] = React.useState<GraphDispSetting>({
    yMin: 0,
    yMax: 0,
  });

  const [flgTSDlg, actTSDlg] = useModal<TrendSettingDialogResponse>();

  useEffect(() => {
    getGroupNoData(trendGraphPageData.selectGroupNo);
  }, []);

  const getGroupNoData = (groupNo: number) => {
    GetTrendSettingList(groupNo.toString()).then((result) => {
      //左側アイテムをデフォルト選択
      if (result.length && result[0].PLCNo !== '0') {
        result.forEach((row) => (row.IsRowSelect = false));
        result[0].IsRowSelect = true;
      }
      console.debug(['getGroupNoData★', result]);
      setTrendSettingList([...result]);
      setTrendGraphPageData({
        ...trendGraphPageData,
        selectGroupNo: groupNo,
        dataUpDateTime: dayjs().format('YYYY-MM-DD hh:mm:ss'),
      });
    });
  };

  const changeGroupSelectNo = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    let gpNo = Number(event.target.value);
    getGroupNoData(gpNo);
    setTrendGraphPageData({ ...trendGraphPageData, selectGroupNo: gpNo });
  };

  const changeTrendSettingData = (datas: TrendManagementSettingType[]) => {
    var selectCount = datas.filter((r) => r.IsDataSelect).length;
    if (selectCount >= 2) {
      //今の選択状態によって日時の選択を制御する
      // ・項目選択は三つまでしか選択できない。
      // ・項目選択を二つ以上選択したとき、日付は一つしか選択できない。
      // ・日付を二つ以上選択したとき、項目は一つしか選択できない。
      setDate2('');
      setDate3('');
      setSelectIndex(1);
    }
    setTrendSettingList([...datas]);
  };

  //傾向管理設定ダイアログ
  const showTrendSettingDialog = () => {
    actTSDlg
      .open()
      .apply((resp) => {
        getGroupNoData(trendGraphPageData.selectGroupNo);
      })
      .cancel((resp) => {
        //console.debug(['cancel()',]);
      });
  };
  const tsdlg = flgTSDlg ? <TrendSettingDialog dialog={actTSDlg} groupNo={trendGraphPageData.selectGroupNo} /> : null;

  const changeCalendarValue = (value: string) => {
    setTrendGraphPageData({ ...trendGraphPageData, targetDay: value });
  };

  /**
   * 日付選択テキストボックスカレント番号変更通知
   * @param index
   */
  const changeSelectDateIndex = (index: number) => {
    var selectCount = trendSettingList.filter((r) => r.IsDataSelect).length;
    if (selectCount >= 2) {
      //今の選択状態によって日時の選択を制御する
      // ・項目選択は三つまでしか選択できない。
      // ・項目選択を二つ以上選択したとき、日付は一つしか選択できない。
      // ・日付を二つ以上選択したとき、項目は一つしか選択できない。
      setSelectIndex(1);
    } else {
      setSelectIndex(index);
    }
  };

  /**
   * 日付選択テキストボック値削除
   * @param index
   */
  const deleteSelectData = (index: number) => {
    if (index == 1) {
      setDate1('');
    } else if (index == 2) {
      setDate2('');
    } else {
      setDate3('');
    }
  };

  const changeSelectDateTime = (value: string) => {
    if (dayjs(value).isValid()) {
      var t = dayjs(value).format('YYYY-MM-DD');
      if (t !== '1970-01-01') {
        switch (selectIndex) {
          case 1:
            setDate1(t);
            break;
          case 2:
            setDate2(t);
            break;
          case 3:
            setDate3(t);
            break;
          default:
            break;
        }
      }
    }
  };

  const handleGraphSettingChange = (data: GraphDispSetting) => {
    console.debug(['★handleGraphSettingChange YMin、YMax★', data.yMin, data.yMax]);
    SetGraphDispSetting({ ...data });
  };

  const handleYMinMaxChange = (min: number, max: number) => {
    if (max == Infinity) {
      return;
    }
    if (min == Infinity) {
      return;
    }
    console.debug(['★handleYMinMaxChange YMin、YMax★', min, max]);
    SetGraphDispSetting({ ...graphDispSetting, yMin: min, yMax: max });
  };

  return (
    <div>
      <Box display="flex" justifyContent="flex-start" alignItems="center">
        <div style={{ width: 10 }}></div>
        <TrendGraphPageComboBox onChangeEvent={changeGroupSelectNo} defalutIndex={trendGraphPageData.selectGroupNo} />
        <div style={{ width: 50 }}></div>
        <DateInput
          onDateChange={changeCalendarValue}
          label={t('TrendGraphPage.グラフ起点日', 'グラフ起点日：')}
          initialValue={trendGraphPageData.targetDay}
          labelPosition={1}
        />
        <div style={{ width: 50 }}></div>
        <TrendGraphDaySelects
          date1={date1}
          date2={date2}
          date3={date3}
          selectIndex={selectIndex}
          onChangeDateSelectIndex={changeSelectDateIndex}
          onDeleteDateSelectIndex={deleteSelectData}
        />
        <div style={{ width: 50 }}></div>
        <TrendGraphChartSetting settingData={graphDispSetting} onChange={handleGraphSettingChange} />
      </Box>

      <Grid container justify="flex-start" spacing={1} direction="row" alignItems="center" style={{ marginTop: 1 }}>
        {/* グラフ情報ヘッダ */}
        <Grid item xs={1} style={{ fontSize: '0.7em' }}>
          <TrendGraphItemHeader />
        </Grid>
        {/* グラフ情報リスト */}
        <Grid item xs={11} style={{ fontSize: '0.7em' }}>
          <TrendGraphItemInfoList
            trendSettingList={trendSettingList}
            selectGroupNo={trendGraphPageData.selectGroupNo}
            onChangeTrandSettingData={changeTrendSettingData}
            onShowTrendSettingDialog={showTrendSettingDialog}
          />
        </Grid>
      </Grid>

      <Grid container justify="flex-start" spacing={0} direction="row" alignItems="center" style={{ marginTop: 1 }}>
        <Grid item xs={12}>
          <TrendGraphChart
            onChagneYMinMax={handleYMinMaxChange}
            targetDay={trendGraphPageData.targetDay}
            trendSettingList={trendSettingList}
            chartContainerStyle={classes.responsiveContainer}
            onChengeDateTime={changeSelectDateTime}
            graphDispSetting={graphDispSetting}
            trendGraphPageData={trendGraphPageData}
          />
        </Grid>
        <Grid
          container
          justify="flex-start"
          spacing={0}
          direction="row"
          alignItems="center"
          style={{ marginTop: 5, padding: 5 }}
        >
          <Grid item xs={11}>
            <TrendGraphButtonList trendSettingList={trendSettingList} date1={date1} date2={date2} date3={date3} />
          </Grid>
        </Grid>
      </Grid>
      {tsdlg}
    </div>
  );
};

export default TrendGraphPage;
